module.exports = __webpack_public_path__ + "img/4.ce1802e3.jpg";